var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoGeolocalisation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.753,
    height: 20.176,
    viewBox: "0 0 14.753 20.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_86",
    "data-name": "Groupe 86",
    transform: "translate(-1084.339 -1906.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_86-2",
    "data-name": "Groupe 86",
    transform: "translate(1084.339 1906.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_38",
    "data-name": "Trac\\xE9 38",
    d: "M1091.119,1906.9a7.353,7.353,0,0,0-1.833,14.28.75.75,0,0,1,.539.576c.483,1.6.991,3.2,1.5,4.8a.824.824,0,0,0,.179.411c.2.175.446.07.547-.247q.625-1.963,1.24-3.929a6.15,6.15,0,0,1,.438-1.325c.244-.408.805-.394,1.214-.6a7.365,7.365,0,0,0-3.82-13.968Zm.6,12.214a4.882,4.882,0,1,1,4.884-4.859A4.9,4.9,0,0,1,1091.715,1919.113Z",
    transform: "translate(-1084.339 -1906.872)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoGeolocalisation);
export default __webpack_public_path__ + "static/media/picto-geolocalisation.2664c52daac8c9b476c9cdc5708676c3.svg";
export { ForwardRef as ReactComponent };